import { motion } from "motion/react";
import { CirclePlus, Joystick, Rocket, type LucideIcon } from "lucide-react";
import { Reveal, useReducedMotion } from "./motion";

const steps: { n: string; Icon: LucideIcon; title: string; body: string }[] = [
  {
    n: "1",
    Icon: CirclePlus,
    title: "Add the app to Discord",
    body: "One tap installs the activity. No downloads, no accounts, nothing to update.",
  },
  {
    n: "2",
    Icon: Rocket,
    title: "Join a voice channel & hit the rocket",
    body: "Open the activity launcher in any voice call and pick the emulator from the shelf.",
  },
  {
    n: "3",
    Icon: Joystick,
    title: "Pick a console, drop in a ROM, play",
    body: "Choose a system, load your own game file, and the screen lights up for everyone watching.",
  },
];

export function HowToPlay() {
  const reduced = useReducedMotion();

  return (
    <section id="how-to-play" className="relative mx-auto max-w-6xl scroll-mt-12 px-5 py-24">
      <Reveal className="text-center">
        <p className="lp-section-label">Three steps to play</p>
        <h2 className="lp-pixel mt-4 text-[1.6rem] leading-tight text-text-primary sm:text-[2.4rem]">
          FROM ZERO TO <span className="lp-neon-blurple">PLAY</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-5 md:grid-cols-3">
        {steps.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.1}>
            <div className="lp-panel flex h-full flex-col gap-4 p-7">
              <div className="flex items-center gap-4">
                <span
                  className="lp-pixel flex h-12 w-12 shrink-0 items-center justify-center rounded-lg text-xl"
                  style={{
                    color: "var(--crt-neon)",
                    background: "rgba(65,255,201,0.08)",
                    border: "1px solid rgba(65,255,201,0.3)",
                    textShadow: "0 0 10px rgba(65,255,201,0.7)",
                  }}
                >
                  {s.n}
                </span>
                <motion.span
                  aria-hidden
                  style={{ color: "var(--crt-neon)" }}
                  animate={reduced ? undefined : { y: [0, -5, 0] }}
                  transition={
                    reduced
                      ? undefined
                      : { duration: 2.4, repeat: Infinity, ease: "easeInOut", delay: i * 0.3 }
                  }
                >
                  <s.Icon size={28} strokeWidth={1.75} />
                </motion.span>
              </div>
              <h3 className="text-lg font-bold text-text-primary">{s.title}</h3>
              <p className="text-sm leading-relaxed" style={{ color: "var(--crt-ink-dim)" }}>
                {s.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
